import auth from './auth'
import in_app_web from './in_app_web'
import public_web from './public'

export default [
  ...auth,
  ...in_app_web,
  ...public_web,
  {
    path: '/web/(.*)',
    beforeEnter(routeTo, routeFrom, resolve, reject) {
      reject()
      const path = routeTo.path.replace(/^\/web/, '')
      this.navigate(path, { animate: false })
    },
    component: require('@/pages/Public/Coaches').default,
  },
  {
    path: '(.*)',
    component: require('@/pages/Public/Coaches').default,
  },
]
